module.exports = __webpack_public_path__ + "img/aidtools_guchebao.c923fb70.png";